export default {
  getList (VueApp, callback) {
    let pricing = VueApp.$store.state.pricing
    let serviceArea = pricing.serviceArea
    VueApp.$sdk.get('/servicearea', {
      token: VueApp.$store.state.session.sessionToken,
      brandId: pricing.brandId,
      status: 'active',
      order: 'priority',
      orderAsc: serviceArea.orderAsc,
      pageNum: 1,
      pageSize: 9999
    }, res => {
      if (!res.error) {
        // VueApp.$store.commit('pricing/setServiceAreaMaxList', res.paging.totalItems)
        if (res.list.length) {
          let serviceArea = []
          for (let i = 0; i < res.list.length; i++) {
            let data = res.list[i]
            serviceArea.push({
              id: data.id,
              name: data.name,
              color: data.color,
              isMTechPricing: data.isMTechPricing || false
            })
          }

          VueApp.$store.commit('pricing/setServiceAreaList', serviceArea)
        }
      }
      callback(res)
    }, '2.0')
  },
  toggleEnable (VueApp, data, callback) {
    VueApp.$sdk.post('/servicearea/' + data.serviceAreaId + '/pricing', {
      token: VueApp.$store.state.session.sessionToken,
      services: [
        {
          serviceTypeId: data.id,
          enabled: data.enable
        }
      ]
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('pricing/updateServiceTypeEnable', {
          id: data.id,
          field: 'enabled',
          value: data.enable
        })
      }
      callback(res)
    }, '2.0')
  },
  getServiceAreaData (VueApp, id, callback) {
    let self = this

    // Reset all service data
    let brandId = VueApp.$store.state.pricing.brandId
    let services = VueApp.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === brandId && x.brandEnabled)
    for (let service in services) {
      let temp = self.buildFreshData(services[service])
      VueApp.$store.commit('pricing/updateServiceTypeData', temp)
    }

    VueApp.$sdk.get('/servicearea/' + id + '/pricing', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: 1,
      pageSize: 999
    }, res => {
      if (!res.error) {
        if (res.list.length) {
          for (let i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('pricing/updateServiceTypeData', self.buildServiceTypeData(VueApp, res.list[i]))
          }

          const idsToRemove = new Set(res.list.map(item => item.serviceTypeId))
          const result = services.filter(item => !idsToRemove.has(item.id))
          self.buildDefaultServiceData(VueApp, result)
        }
      }
      callback(res)
    }, '2.0')
  },
  buildDefaultServiceData (VueApp, result) {
    result.forEach(x => {
      x.asap = {
        airportFee: 0,
        discountAdmin: true,
        discountAmount: 0,
        discountApp: true,
        discountCSR: true,
        discountEnd: null,
        discountStart: null,
        discountType: "$",
        discountWidget: true,
        fare: 0,
        flat2paxFee: 0,
        flatNpaxFee: 0,
        gasFee: 0,
        holidayDate: null,
        holidayDate2: null,
        holidayDate3: null,
        holidayDate4: null,
        holidayDate5: null,
        holidayDate6: null,
        holidayDate7: null,
        holidayDate8: null,
        holidayDate9: null,
        holidayDate10: null,
        holidayRateAmount: 0,
        holidayRateType: "$",
        mileageRate: 0,
        mileageThreshold: 0,
        pickupInstructions: null,
        prov2paxFee: 0,
        provBaseFee: 0,
        provBonus: 0,
        provDiscountRate: 0,
        provMileage: 0,
        provNpaxFee: 0,
        roundtripAmount: 0,
        roundtripType: "$",
        travelInsurance: 0
      }
      x.future = {
        airportFee: 0,
        discountAdmin: true,
        discountAmount: 0,
        discountApp: true,
        discountCSR: true,
        discountEnd: null,
        discountStart: null,
        discountType: "$",
        discountWidget: true,
        fare: 0,
        flat2paxFee: 0,
        flatNpaxFee: 0,
        gasFee: 0,
        holidayDate: null,
        holidayDate2: null,
        holidayDate3: null,
        holidayDate4: null,
        holidayDate5: null,
        holidayDate6: null,
        holidayDate7: null,
        holidayDate8: null,
        holidayDate9: null,
        holidayDate10: null,
        holidayRateAmount: 0,
        holidayRateType: "$",
        mileageRate: 0,
        mileageThreshold: 0,
        pickupInstructions: null,
        prov2paxFee: 0,
        provBaseFee: 0,
        provBonus: 0,
        provDiscountRate: 0,
        provMileage: 0,
        provNpaxFee: 0,
        roundtripAmount: 0,
        roundtripType: "$",
        travelInsurance: 0
      }
      x.flight = {
        onewayRate: null,
        onewayType: "$",
        roundtripRate: null,
        roundtripType: "$"
      }
      x.pickupTypes = {
        Curbside: {name: "Curbside", fee: 0, enabled: true},
        MeetAndGreet: {name: "MeetAndGreet", fee: 0, enabled: false}
      }
      x.rental = {
        rentFare: null,
        rentRate: null,
        rentRateDaily: null,
        rentRateWeekend: null
      }
      x.serviceTypeId = x.id
      VueApp.$store.commit('pricing/updateServiceTypeData', x)
    })
  },
  setGlobalData (VueApp, callback) {
    let serviceTypes = VueApp.$store.state.pricing.serviceTypes.list.filter(serviceType => {
      return serviceType.brandId === VueApp.$store.state.pricing.brandId
    })
    for (let service in serviceTypes) {
      let serviceType = Object.assign({}, serviceTypes[service])

      delete serviceType.serviceTypeId
      // delete serviceType.enabled
      serviceType.enabled = true
      serviceType.future = {
        travelInsurance: '',
        airportFee: '',
        discountAmount: '',
        discountType: '',
        fare: '',
        flat2paxFee: '',
        flatNpaxFee: '',
        holidayRateAmount: '',
        holidayRateType: '',
        mileageRate: '',
        mileageThreshold: '',
        prov2paxFee: '',
        provBaseFee: '',
        provBonus: '',
        provDiscountRate: '',
        provMileage: '',
        provNpaxFee: '',
        roundtripAmount: '',
        roundtripType: '',
        discountStart: '',
        discountEnd: '',
        holidayDate: '',
        gasFee: '',
        portalFee: '',
        portalFeeType: ''
      }
      serviceType.flight = {
        onewayType: '',
        onewayRate: '',
        roundtripType: '',
        roundtripRate: ''
      }
      serviceType.rental = {
        rentFare: '',
        rentRate: '',
        rentRateDaily: '',
        rentRateWeekend: ''
      }
      serviceType.asap = {
        travelInsurance: '',
        airportFee: '',
        mileageRate: '',
        fare: '',
        mileageThreshold: '',
        flat2paxFee: '',
        flatNpaxFee: '',
        discountType: '',
        discountAmount: '',
        roundtripType: '',
        roundtripAmount: '',
        discountStart: '',
        discountEnd: '',
        provMileage: '',
        provBaseFee: '',
        provBonus: '',
        prov2paxFee: '',
        provNpaxFee: '',
        provDiscountRate: '',
        holidayRateType: '',
        holidayRateAmount: '',
        holidayDate: '',
        gasFee: '',
        portalFee: '',
        portalFeeType: ''
      }
      serviceType.charter = {
        fare: '',
        minuteRate: '',
        provBase: '',
        provDiscount: '',
        provRate: '',
        portalFee: '',
        portalFeeType: ''
      }

      serviceType.pickupTypes = {
        Curbside: { name: 'Curbside', fee: '', enabled: '' },
        MeetAndGreet: { name: 'MeetAndGreet', fee: '', enabled: '' }
      }

      for (let i = 1; i < 10; i++) {
        VueApp.$store.commit('pricing/setHolidayData', {
          type: 'asap',
          index: i + 1,
          value: ''
        })
        VueApp.$store.commit('pricing/setHolidayData', {
          type: 'future',
          index: i + 1,
          value: ''
        })
        VueApp.$store.commit('pricing/setCharterHolidayData', {
          index: i + 1,
          value: ''
        })
      }

      VueApp.$store.commit('pricing/updateServiceTypeData', serviceType)
    }
    callback(1)
  },
  buildServiceTypeData (VueApp, data) {
    let serviceTypes = VueApp.$store.state.pricing.serviceTypes.list
    let index = serviceTypes.findIndex(x => x.id === data.serviceTypeId)
    let serviceType = Object.assign({}, serviceTypes[index])
    
    serviceType.serviceTypeId = data.serviceType.id
    serviceType.enabled = data.enabled
    serviceType.future = data.future
    serviceType.asap = data.asap
    serviceType.flight = data.flight
    serviceType.rental = data.rental
    for (let x in data.asap) {
      if (data.asap[x] === null) {
        serviceType.asap[x] = data.future[x]
      }
    }
    serviceType.discountStart = null
    serviceType.discountEnd = null
    serviceType.discountWidget = data.future.discountWidget
    serviceType.discountAdmin = data.future.discountAdmin
    serviceType.discountApp = data.future.discountApp
    serviceType.discountCSR = data.future.discountCSR
    serviceType.holidayDate = null
    serviceType.holidayDate2 = null
    serviceType.holidayDate3 = null
    serviceType.holidayDate4 = null
    serviceType.holidayDate5 = null
    serviceType.holidayDate6 = null
    serviceType.holidayDate7 = null
    serviceType.holidayDate8 = null
    serviceType.holidayDate9 = null
    serviceType.holidayDate10 = null
    serviceType.asapDiscountStart = null
    serviceType.asapDiscountEnd = null
    serviceType.asapDiscountWidget = data.asap.discountWidget
    serviceType.asapDiscountAdmin = data.asap.discountAdmin
    serviceType.asapDiscountApp = data.asap.discountApp
    serviceType.asapDiscountCSR = data.asap.discountCSR
    serviceType.asapHolidayDate = null
    serviceType.asapHolidayDate2 = null
    serviceType.asapHolidayDate3 = null
    serviceType.asapHolidayDate4 = null
    serviceType.asapHolidayDate5 = null
    serviceType.asapHolidayDate6 = null
    serviceType.asapHolidayDate7 = null
    serviceType.asapHolidayDate8 = null
    serviceType.asapHolidayDate9 = null
    serviceType.asapHolidayDate10 = null
    if (data.future && data.future.discountStart) serviceType.discountStart = data.future.discountStart
    if (data.future && data.future.discountEnd) serviceType.discountEnd = data.future.discountEnd
    if (data.future && data.future.holidayDate) serviceType.holidayDate = data.future.holidayDate
    serviceType.holidayDate2 = data.future.holidayDate2 || null
    serviceType.holidayDate3 = data.future.holidayDate3 || null
    serviceType.holidayDate4 = data.future.holidayDate4 || null
    serviceType.holidayDate5 = data.future.holidayDate5 || null
    serviceType.holidayDate6 = data.future.holidayDate6 || null
    serviceType.holidayDate7 = data.future.holidayDate7 || null
    serviceType.holidayDate8 = data.future.holidayDate8 || null
    serviceType.holidayDate9 = data.future.holidayDate9 || null
    serviceType.holidayDate10 = data.future.holidayDate10 || null
    if (data.asap && data.asap.discountStart) serviceType.asapDiscountStart = data.asap.discountStart
    if (data.asap && data.asap.discountEnd) serviceType.asapDiscountEnd = data.asap.discountEnd
    if (data.asap && data.asap.holidayDate) serviceType.asapHolidayDate = data.asap.holidayDate
    serviceType.asapHolidayDate2 = data.asap.holidayDate2 || null
    serviceType.asapHolidayDate3 = data.asap.holidayDate3 || null
    serviceType.asapHolidayDate4 = data.asap.holidayDate4 || null
    serviceType.asapHolidayDate5 = data.asap.holidayDate5 || null
    serviceType.asapHolidayDate6 = data.asap.holidayDate6 || null
    serviceType.asapHolidayDate7 = data.asap.holidayDate7 || null
    serviceType.asapHolidayDate8 = data.asap.holidayDate8 || null
    serviceType.asapHolidayDate9 = data.asap.holidayDate9 || null
    serviceType.asapHolidayDate10 = data.asap.holidayDate10 || null

    let pickupTypes = {}
    if (data.pickupTypes && data.pickupTypes.length > 0) {
      data.pickupTypes.forEach(pickupType => {
        pickupTypes[pickupType.name] = pickupType
      })
    } else {
      pickupTypes = {
        Curbside: { name: 'Curbside', fee: 0, enabled: false },
        MeetAndGreet: { name: 'MeetAndGreet', fee: 0, enabled: false }
      }
    }
    serviceType.pickupTypes = pickupTypes
    serviceType.brandEnabled = data.serviceType.enabled
    serviceType.isShared = data.serviceType.isShared === 1

    if (data.serviceType.isCharter) {
      serviceType.charter = {
        // airportFee: data.future.airportFee || '',
        fare: data.charter.fare,
        minuteRate: data.charter.minuteRate,
        // discountAmount: data.future.discountAmount || '',
        provBase: data.charter.provBase,
        provDiscount: data.charter.provDiscount,
        provRate: data.charter.provRate,
        portalFee: data.future.portalFee || '',
        portalFeeType: data.future.portalFeeType || '',
      }
    }

    serviceType.flight = {}
    if (data.flight) {
      if (data.flight.oneway) {
        serviceType.flight.onewayType = data.flight.oneway.type || null
        serviceType.flight.onewayRate = data.flight.oneway.rate || null
      }
      if (data.flight.roundtrip) {
        serviceType.flight.roundtripType = data.flight.roundtrip.type || null
        serviceType.flight.roundtripRate = data.flight.roundtrip.rate || null
      }
    }

    return serviceType
  },
  buildFreshData (data) {
    data.enabled = false
    data.travelInsurance = 0
    data.airportFee = 0
    data.gasFee = 0
    data.discountAmount = 0
    data.discountType = '$'
    data.fare = 0
    data.flat2paxFee = 0
    data.flatNpaxFee = 0
    data.holidayRateAmount = 0
    data.holidayRateType = '$'
    data.mileageRate = 0
    data.mileageThreshold = 0
    data.prov2paxFee = 0
    data.provBaseFee = 0
    data.provBonus = 0
    data.provDiscountRate = 0
    data.provMileage = 0
    data.provNpaxFee = 0
    data.roundtripAmount = 0
    data.roundtripType = '$'
    data.discountStart = ''
    data.discountEnd = ''
    data.holidayDate = ''

    return data
  }
}


// WEBPACK FOOTER //
// ./src/modules/api/pricing/service-area.js